export const VIDEO_TYPE = 'video/mp4';
